export class HTTPError extends Error {
  constructor(message, statusCode = 500, details = null) {
    super(message); // Call the parent class constructor with the error message
    this.name = this.constructor.name; // Set the name of the error
    this.statusCode = statusCode; // HTTP status code (e.g., 400, 404, 500)
    this.details = details; // Optional additional details
    Error.captureStackTrace(this, this.constructor); // Capture the stack trace (optional)
  }
}